import { useParams } from 'react-router';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';
import { fromUrlSlug } from 'utils/stepUrlUtils';

/**
 * Returns the current step from URL params
 */
const useCurrentStep = (): SelfServiceSteps | null => {
  const { step } = useParams<{ step: string }>();

  if (step) {
    try {
      return fromUrlSlug(step);
    } catch {
      return null;
    }
  }
  return null;
};

export default useCurrentStep;
